module.exports = __webpack_public_path__ + "56882b6564fb4925616cadd0cdf8296f.svg";